export function isRTLDirection() {
  const html = document.querySelector('html');
  if (!html) return false;

  return html.getAttribute('dir') === 'rtl';
}

export function rtlInvertedNumber(value: number) {
  return isRTLDirection() ? value * -1 : value;
}

export function rtlInvertedBoolean(value: boolean | number) {
  return isRTLDirection() ? Math.abs(Number(value)) - 1 : Number(value);
}
